import { apiAuth, apiResponseType } from ".";

export const createAdjustmentRequest = (data) =>
  apiAuth.postForm(
    "/time-entry-adjustment-requests/store",
    data
  ) as apiResponseType;

export const getMyAdjustmentRequests = (page: number = 1): apiResponseType =>
  apiAuth.get(`time-entry-adjustment-requests/my-requests?page=${page}`);

export const getMyPendingApprovals = (page: number = 1): apiResponseType =>
  apiAuth.get(`time-entry-adjustment-requests/my-pending-approvals?page=${page}`);

export const getPendingForReview = (
  page: number = 1,
  unity_id?: string,
  name?: string
): apiResponseType =>
  apiAuth.get(
    `time-entry-adjustment-requests/pending-for-review?page=${page}${
      unity_id ? `&unity_id=${unity_id}` : ""
    }${name ? `&name=${encodeURIComponent(name)}` : ""}`
  );

export const approveAdjustmentRequest = (uuid: string, note?: string) =>
  apiAuth.put(`time-entry-adjustment-requests/${uuid}/approve`, {
    note,
  }) as apiResponseType;

export const rejectAdjustmentRequest = (uuid: string, note: string) =>
  apiAuth.put(`time-entry-adjustment-requests/${uuid}/reject`, {
    note,
  }) as apiResponseType;
